import { ComparisonSpec } from './ComparisonSpec';

export interface MarkBasedComparisonSpec extends ComparisonSpec {
  readonly type: 'MARK_BASED_COMPARISON';
  readonly numberOfMarks: number;
}

/**
 * @param message The user facing string to describe this spec. Unused outside
 * the adjust and compare screen in phoenix.
 * @param numberOfMarks The number of marks to look back. Defaults to 1 if unset.
 */
export const makeMarkBasedComparisonSpec = (message: string, numberOfMarks?: number): MarkBasedComparisonSpec => {
  return {
    type: 'MARK_BASED_COMPARISON',
    numberOfMarks: numberOfMarks ?? 1,
    message,
  };
};
